import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './Popup.scss';
import MaterialIcon from '@material/react-material-icon';

const Popup = ({
  isOpen,
  togglePopup,
  title,
  children,
  closeButton,
  isOverflow = false,
  maxHeight = false,
}) => {
  useEffect(() => {
    const overlay = document.querySelector('.popup-overlay');
    if (overlay) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return (
    isOpen && (
      <>
        <div className="popup-container">
          <div className="popup-overlay"></div>
          <div className="popup">
            <h6 className="fw-bold">{title}</h6>
            {(closeButton || closeButton === undefined) && (
              <div className="popup-close">
                <MaterialIcon icon="close" onClick={() => togglePopup()} />
              </div>
            )}
            <hr style={{ marginTop: '0px' }} />
            <div
              className={`popup-content p-1 ${isOverflow ? 'overflow-y-auto' : ''} ${
                maxHeight ? 'max-height' : ''
              }`}
            >
              {children}
            </div>
          </div>
        </div>
      </>
    )
  );
};

Popup.propTypes = {
  isOpen: PropTypes.bool,
  togglePopup: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  closeButton: PropTypes.bool,
  isOverflow: PropTypes.bool,
  maxHeight: PropTypes.bool, // true -> tinggi maksimal popup, false -> tinggi sesuai konten
};

export default Popup;
